import { appConfigSchema, type AppConfig } from './types'

let config: AppConfig | null = null

/**
 * Грузится один раз в main.tsx до первого рендера.
 * Один билд на все окружения: адреса подменяются файлом public/config.json при деплое.
 */
export async function loadRuntimeConfig(): Promise<AppConfig> {
  const response = await fetch('/config.json', { cache: 'no-store' })
  if (!response.ok) {
    throw new Error(`Не удалось загрузить config.json: ${response.status}`)
  }

  config = appConfigSchema.parse(await response.json())
  return config
}

export function getConfig(): AppConfig {
  if (!config) {
    throw new Error('Конфиг ещё не загружен — вызови loadRuntimeConfig() до рендера')
  }
  return config
}

export function isFeatureEnabled(name: string): boolean {
  return getConfig().features[name] === true
}
